import styled from "styled-components";

export const Button = styled.button`
	background: var(--gradient);
	padding: 12px 20px;
	border-radius: 10rem;
	color: white;
	font-size: 16px;
	border: none;
	cursor: pointer;
	position: relative;
	transform-style: preserve-3d;
	z-index: 10;

	&::after {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
		border-radius: 30px;
		background: var(--gradient);
		filter: blur(5px);
		z-index: -1;
		transform: translateZ(-1px);
	}
`;
